import PropTypes from 'prop-types';
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return searchQuery ? (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        یافت نشد
      </Typography>
      <Typography variant="body2" align="center">
        نتیجه ای برای &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong> یافت نشد.
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2"> جستجو کنید</Typography>
  );
}
